<template>
  <div id="xiandai">
    <div class="base">
      <div class="left">
        <div class="top"> {{ lineData.title }}</div>
        <div class="border"></div>
        <div class="center">{{ lineData.listDict }}</div>
        <div class="border"></div>
        <!-- <div class="bottom">{{ lineData.time }}</div> -->
      </div>
      <div class="right">
        <div v-for="item in lineData.topDeviceList" :key="item.id">
        <div class="content" 
         v-for="item2 in item.childList"
            :key="item2.id"
         >
          <div class="top"> {{ item.levelName }}</div>
          <div class="center">{{
              item2.sourceName
            }}</div>
          <div class="center">{{
              item2.surname
            }}</div>
          <div class="bottom">
            <div style="letterSpacing:1px;">
            {{ item2.broThDate }}
            {{ item2.existUser }}
            {{ item2.xifus }}
            {{ item2.formDict }}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { lineChildList, uploadMy } from "@/api";

export default {
  name: "xiandai",
  data() {
    return {
            id: "",
      lineData: [],
      htmlTitle: "宝塔式",
      isDownload: false,
      pdfId:'',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.pdfId = this.$route.query.pdfId;
    this.isDownload = this.$route.query.isDownload;
    this.htmlTitle = this.$route.query.htmlTitle;
    lineChildList(this.id).then((res) => {
      this.lineData = res.data;
    });

    setTimeout(() => {}, 3000);
  },
  updated() {
    this.$nextTick(() => {
      this.getPdf(
        document.getElementById("xiandai"),
        this.htmlTitle,
        this.isDownload
      ).then((res) => {
        if (res) {
          console.log("准备上传");
          this.UploadPdf(res);
        } else {
          console.log("不上传");
        }
      });
    });
  },
  mounted() {},
  methods: {
    //上传pdf接口
    UploadPdf(res) {
      //res拿到base64的pdf
      let pdfBase64Str = res;
      var myfile = this.dataURLtoFile(pdfBase64Str, this.title + ".pdf"); //调用一下下面的转文件流函数
      var formdata = new FormData();
      formdata.append("file", myfile); // 文件对象
      formdata.append("pdfId", this.pdfId); // 文件对象
      //该uploadMy为接口，直接以formdata格式传给后台
      uploadMy(formdata)
        .then((res) => {
          console.log("上传pdf接口", res);
        })
        .catch((err) => {
          console.log("上传pdf接口", err);
        });
    },
    /*
    将base64转换为文件,接收2个参数，第一是base64，第二个是文件名字
    最后返回文件对象
    */
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>
      
      <!-- Add "scoped" attribute to limit CSS to this component only -->
      <style scoped>
.base {
    width: 1920px;
  min-height: 100vh;
  border: 1px solid #000;
  display: flex;
}
.base .left {
    writing-mode: vertical-lr;

  min-height: 100vh;
  width: 50px;
  border-right: 1px solid #000;
  display: flex;
  flex-direction: column;
}
.base .left .top {
  height: 100px;
}
.base .left .center {
  flex: 1;
}
.base .left .bottom {
  height: 100px;
}
.base .left .border {
  width: inherit;
  height: 20px;
  background-color: #000;
}
.base .right {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.base .right .content {
  width: 100%;
  min-height: 100px;
  display: flex;
  border-bottom: 1px solid #000;
}
.base .right .content .top {
  width: 15%;
  border-right: 1px solid #000;
  padding: 10px;
}
.base .right .content .center {
  width: 15%;
  border-right: 1px solid #000;
  padding: 10px;
}
.base .right .content .bottom {
  flex: 1;
  text-align: left;
  padding: 10px;
}
</style>
      


// WEBPACK FOOTER //
// src/view/xiandai.vue